import Framework from './tags/Framework';

function Frameworks() {
  return (
    <div>
      <Framework />
    </div>
  );
}

export default Frameworks;
